const injectCssIntoH5P = () => {
    document.addEventListener("DOMContentLoaded", function () {

        function injectCssIntoH5P() {
            document.querySelectorAll(".h5p-iframe").forEach(function (iframe) {

                iframe.addEventListener("load", function () {
                    let doc = iframe.contentDocument || iframe.contentWindow.document;
                    if (!doc) return;

                    let link = doc.createElement("link");
                    link.rel = "stylesheet";
                    link.type = "text/css";
                    link.href = rcData.h5pStylesheet;

                    doc.head.appendChild(link);
                });
            });
        }

        injectCssIntoH5P();

    });
};

export default injectCssIntoH5P;
